

<h3 class="text-xs-center text-md-left">Selected Recent Projects</h3>
<!-- <div class="projCover" *ngFor="let projCover of projectCovers" (click)="showDetails(projCover)"> -->
    <div class="projCover" *ngFor="let projCover of projectCovers">
    <div class="row" (click)="showDetails(projCover)" >
        <div class="col-sm-3 col-xs-6 cover d-none d-sm-block">
            <img class="cover_image" [src]="projCover.cover_image">
        </div>
        <div class="col-sm-9 col-xs-6">
            <div class="row col-md-12 proj-title">
                <h4>{{projCover.title}}</h4>
            </div>
            <div class="row col-md-12 proj-duration text-md-left">
                  Duration: {{projCover.start_year}} - {{projCover.end_year}}
            </div>
            <div class="row col-md-12 proj-desc text-md-left">
                <div>{{projCover.short_desc}}</div>
            </div>
            <div class="row col-md-12">
                <span class="keywords-heading">Keywords:</span>
                <span class="keys" *ngFor="let keyword of projCover.keywords">
                    {{keyword}};
                </span>
            </div>
        </div>
        
    </div>
    <hr>
</div>

